import { render, staticRenderFns } from "./LicenseInvoice.vue?vue&type=template&id=a68842b2&scoped=true&"
import script from "./LicenseInvoice.vue?vue&type=script&lang=js&"
export * from "./LicenseInvoice.vue?vue&type=script&lang=js&"
import style0 from "./LicenseInvoice.vue?vue&type=style&index=0&id=a68842b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68842b2",
  null
  
)

export default component.exports